module.exports = __webpack_public_path__ + "a29bf850289ca776f302144692165c77.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/explanation-2.svg
// module id = 464
// module chunks = 0